import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { observer } from 'mobx-react';

import { Button } from 'core/components/button';
import BaseDialog from 'core/components/base-dialog';
import { Label } from 'core/components/label';
import { NotificationCard } from 'core/components/notification-card';
import { useToast } from 'core/components/toast';
import useStyles from './confirm-location-delete-modal.styles';

const ConfirmLocationDeleteModal = ({ onClose, locationIndexToRemove }) => {
  const classes = useStyles();
  const { handleSubmit, values, setFieldValue, setFieldTouched } = useFormikContext();
  const toast = useToast();

  const onRemove = async () => {
    const newLocations = values.farmLocations.filter((_, checkIndex) => checkIndex !== locationIndexToRemove);
    const locationName = values.farmLocations[locationIndexToRemove].description;
    setFieldValue('farmLocations', newLocations);
    setFieldTouched('farmLocations');
    onClose();
    toast.notify({
      type: 'success',
      message: `The location named "${locationName}" and it's associated risk have been removed`
    });
    handleSubmit();
  };

  return (
    <BaseDialog className={classes.modal} onClose={onClose} open>
      <div className={classes.container}>
        <Label className={classes.mainLabel} type="green75Big">
          Are you sure you want to remove this location?
        </Label>
        <Label type="subtitle1Regular">This will remove all risks on this location as well.</Label>
        <NotificationCard className={classes.warning} iconSize="icon16Bold" type="light">
          <Label type="body3">You will not be able to undo this action.</Label>
        </NotificationCard>
        <div className={classes.buttonContainer}>
          <Button className={classes.buttons} variant="contained" color="primary" onClick={onRemove}>
            Yes, remove
          </Button>
          <Button variant="contained" color="secondary" onClick={onClose} className={classes.buttons}>
            No, keep
          </Button>
        </div>
      </div>
    </BaseDialog>
  );
};

ConfirmLocationDeleteModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  locationIndexToRemove: PropTypes.number
};

export default observer(ConfirmLocationDeleteModal);
